import { useAtomValue } from 'jotai'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { Helmet } from 'react-helmet-async'

import CustomPaper from '@/components/custom-paper'
import HowToPayLessList from '@/components/how-to-pay-less/list'
import { selectedMunicipalityIdAtom } from '@/state'

function HowToPayLessView() {

    const title = 'Jak platit méně'

    const municipalityId = useAtomValue(selectedMunicipalityIdAtom)

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <CustomPaper>
                <Box position="relative">
                    <Typography variant="h2" component="h1" gutterBottom>
                        {title}
                    </Typography>
                    {municipalityId ?
                        <HowToPayLessList />
                        :
                        <Box>
                            Vyberte prosím konkrétní obec výše.
                        </Box>
                    }
                    
                </Box>
            </CustomPaper>
        </>
    )
}

export default HowToPayLessView
